import { render, staticRenderFns } from "./RevenuesTypeUpdate.vue?vue&type=template&id=24a8dda2&"
import script from "./RevenuesTypeUpdate.vue?vue&type=script&lang=js&"
export * from "./RevenuesTypeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports